import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex w-full"
};
const _hoisted_2 = /*#__PURE__*/_createTextVNode("-");
const _hoisted_3 = {
  class: "mx-1 grow"
};
const _hoisted_4 = ["type", "value", "disabled", "min", "max", "readonly"];
const _hoisted_5 = /*#__PURE__*/_createTextVNode("+");
export default /*#__PURE__*/_defineComponent({
  __name: 'Stepper',
  props: {
    modelValue: {
      default: 0
    },
    min: null,
    max: null,
    step: {
      default: 1
    },
    disabled: {
      type: Boolean
    },
    inputReadonly: {
      type: Boolean
    },
    size: {
      default: 'medium'
    },
    formatter: {
      type: Function,
      default: value => value
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const minusDisabled = computed(() => props.disabled || Number.isInteger(props.min) && props.min >= props.modelValue);
    const plusDisabled = computed(() => props.disabled || Number.isInteger(props.max) && props.max <= props.modelValue);
    const onClickMinus = () => emit('update:modelValue', Number.isInteger(props.min) ? Math.max(props.min, props.modelValue - props.step) : props.modelValue - props.step);
    const onClickPlus = () => emit('update:modelValue', Number.isInteger(props.max) ? Math.min(props.max, props.modelValue + props.step) : props.modelValue + props.step);
    const onChange = event => {
      let target = event.target;
      let value = target.value;
      value = value === '' ? 0 : value;
      value = Number.parseInt(value);
      if (Number.isInteger(value)) {
        value = Math.min(props.max, value);
        value = Math.max(props.min, value);
        target.value = props.formatter(value).toString();
        emit('update:modelValue', value);
        return;
      }
      target.value = props.formatter(value).toString();
      emit('update:modelValue', props.modelValue);
    };
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NButton, {
        secondary: "",
        disabled: _unref(minusDisabled),
        size: __props.size,
        onClick: onClickMinus
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }, 8, ["disabled", "size"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("input", {
        type: __props.inputReadonly ? 'text' : 'number',
        value: __props.formatter(__props.modelValue),
        class: "stepper-input h-full text-center bg-gray-100 text-gray-700 border-0 rounded w-full",
        disabled: __props.disabled || __props.inputReadonly,
        min: __props.min,
        max: __props.max,
        readonly: __props.inputReadonly,
        onChange: onChange,
        onBlur: onChange,
        onFocus: _cache[0] || (_cache[0] = $event => $event.target.select()),
        onKeydown: _cache[1] || (_cache[1] = _withKeys($event => $event.target.blur(), ["enter"]))
      }, null, 40, _hoisted_4)]), _createVNode(_component_NButton, {
        secondary: "",
        disabled: _unref(plusDisabled),
        size: __props.size,
        onClick: onClickPlus
      }, {
        default: _withCtx(() => [_hoisted_5]),
        _: 1
      }, 8, ["disabled", "size"])]);
    };
  }
});